import 'normalize.css/normalize.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'vuetify/dist/vuetify.min.css';

// mixins.
import deviceMixin from '@/mixins/deviceMixin';
import permissionsMixin from '@/mixins/permissionsMixin';
import attachmentsPreviewMixin from '@/mixins/attachmentsPreviewMixin';

// libs.
import Vue from 'vue';
import Amplify from '@aws-amplify/core';
import vuelidate from 'vuelidate';
import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor';
import Draggable from 'vuedraggable';
import PortalVue from 'portal-vue';
import permission from '@/store/modules/permission';
import { i18n } from './i18n';
import vuetify from './plugins/vuetify';
import './styles/main.scss';

import App from './App.vue';
import router from './router';
import createStore from './store';
import awsconfig from './aws-exports';
import './router/permission';

Amplify.configure(awsconfig);

// add components.
Vue.component('Draggable', Draggable);

// add mixins.
Vue.mixin(deviceMixin);
Vue.mixin(permissionsMixin);
Vue.mixin(attachmentsPreviewMixin);

// add libs.
Vue.use(vuelidate);
Vue.use(PortalVue);
Vue.use(vuelidateErrorExtractor, {
  /**
   * Optionally provide the template in the configuration.
   * or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
   */
  template: templates.singleErrorExtractor.foundation6, // you can also pass your own custom template.
  messages: { required: 'The {attribute} field is required' }, // error messages to use.
});

const store = createStore();
store.registerModule('permission', permission);

new Vue({
  components: {},
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
